import { getParams } from './searchParams';

export const getRetailerFromUrl = (): string | null => {
  if (typeof window === 'undefined') return null;

  const params = getParams() ?? {};
  const { retailer, shid } = params;

  if (retailer) return retailer;

  if (shid) {
    return null;
  }

  const pathParts = window.location.pathname.split('/').filter(Boolean);
  if (pathParts[0]) {
    return pathParts[0];
  }

  return null;
};
